import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { memberRegistrationApi } from "../features/api/memberRegistrationApi";
import memberRegistrationReducer from "../features/slices/slice";
import companyProfileReducer from "../features/slices/companyProfileSlice";
import { companyProfileApi } from "../features/api/companyProfileApi";
import memberRenewalReducer from "../features/slices/memberRenewalSlice";
import { memberRenewalApi } from "../features/api/memberRenewalApi";
import { proofOfPaymentApi } from "../features/api/proofOfPaymentApi";
import { paymentApi } from "../features/api/paymentApi";
import { mvdApi } from "../features/api/mvdApi";

import proofOfPaymentReducer from "../features/slices/proofOfPaymentSlice";
import mvdReducer from "../features/slices/mvdSlice";
import { packagingSubCategoriesApi } from "../features/api/packagingSubCategoriesApi";
import { contactPersonApi } from "../features/api/contactPersonApi";
import contactPersonReducer from "../features/slices/contactPersonSlice";
import { userApi } from "../features/api/userApi";
import { eprSubCategoriesApi } from "../features/api/eprSubCategoriesApi";
import { memberCategoryApi } from "../features/api/memberCategoryApi";
import { wasteStreamsApi } from "../features/api/wasteStreamsApi";
import memberCategoryReducer from "../features/slices/memberCategorySlice";
import wasteStreamsReducer from "../features/slices/wasteStreamsSlice";

import mvdTableReducer from "../features/slices/mvdTableSlice";
import { mvdTableApi } from "../features/api/mvdTableApi";
import userReducer from "../features/auth/userSlice";
import { changeRequestApi } from "../features/api/changeRequestApi";
import changeRequestReducer from "../features/slices/changeRequestSlice";
import { notificationsApi } from "../features/api/notificationApi";
import { reportsApi } from "../features/api/reportsApi";
import { mfaApi } from "../features/api/mfaApi";
import { authApi } from "../features/api/authApi";
import { roleInValueChainApi } from "../features/api/roleInValueChainApi";
import { statusApi } from "../features/api/statusApi";
import { transitionApi } from "../features/api/transitionApi";
import { categoryApi } from "../features/api/industryCategoryApi";
import { roleApi } from "../features/api/roleApi";
import { documentValidationApi } from "../features/api/documentValidationApi";
import { moduleRoleApi } from "../features/api/moduleRoleApi";
import { adSearchApi } from "../features/api/adSearchApi";
import { commentsApi } from "../features/api/commentsApi";
import { faqApi } from "../features/api/faqApi";
import { tutorialApi } from "../features/api/tutorialApi";
import {productCatalogApi} from "../features/api/productCatalogApi";
import { supportApi } from "../features/api/supportApi";

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [memberRegistrationApi.reducerPath]: memberRegistrationApi.reducer,
    memberRegistration: memberRegistrationReducer,
    [companyProfileApi.reducerPath]: companyProfileApi.reducer,
    companyProfile: companyProfileReducer,
    [memberRenewalApi.reducerPath]: memberRenewalApi.reducer,
    memberRenewal: memberRenewalReducer,
    proofOfPayment: proofOfPaymentReducer,
    mvd: mvdReducer,
    mvdTable: mvdTableReducer,

    [proofOfPaymentApi.reducerPath]: proofOfPaymentApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [mvdApi.reducerPath]: mvdApi.reducer,
    [mvdTableApi.reducerPath]: mvdTableApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [moduleRoleApi.reducerPath]: moduleRoleApi.reducer,

    [packagingSubCategoriesApi.reducerPath]: packagingSubCategoriesApi.reducer,
    [contactPersonApi.reducerPath]: contactPersonApi.reducer,
    contactPerson: contactPersonReducer,
    [userApi.reducerPath]: userApi.reducer,
    [eprSubCategoriesApi.reducerPath]: eprSubCategoriesApi.reducer,
    [memberCategoryApi.reducerPath]: memberCategoryApi.reducer,
    [wasteStreamsApi.reducerPath]: wasteStreamsApi.reducer,
    [roleInValueChainApi.reducerPath]: roleInValueChainApi.reducer,
    [statusApi.reducerPath]: statusApi.reducer,
    [transitionApi.reducerPath]: transitionApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [roleApi.reducerPath]: roleApi.reducer,
    [documentValidationApi.reducerPath]: documentValidationApi.reducer,
    memberCategory: memberCategoryReducer,
    wasteStreams: wasteStreamsReducer,
    user: userReducer,
    [changeRequestApi.reducerPath]: changeRequestApi.reducer,
    changeRequest: changeRequestReducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
    [mfaApi.reducerPath]: mfaApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    //search api slice added
    [adSearchApi.reducerPath]: adSearchApi.reducer,
    [commentsApi.reducerPath]: commentsApi.reducer,
    [faqApi.reducerPath]: faqApi.reducer,
    [tutorialApi.reducerPath]: tutorialApi.reducer,
    [productCatalogApi.reducerPath]: productCatalogApi.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      memberRegistrationApi.middleware,
      companyProfileApi.middleware,
      memberRenewalApi.middleware,
      proofOfPaymentApi.middleware,
      paymentApi.middleware,
      mvdApi.middleware,
      mvdTableApi.middleware,
      moduleRoleApi.middleware,

      packagingSubCategoriesApi.middleware,
      userApi.middleware,
      eprSubCategoriesApi.middleware,
      contactPersonApi.middleware,
      memberCategoryApi.middleware,
      wasteStreamsApi.middleware,
      roleInValueChainApi.middleware,
      statusApi.middleware,
      transitionApi.middleware,
      categoryApi.middleware,
      roleApi.middleware,
      documentValidationApi.middleware,
      changeRequestApi.middleware,
      notificationsApi.middleware,
      reportsApi.middleware,
      mfaApi.middleware,
      authApi.middleware,
      adSearchApi.middleware,
      commentsApi.middleware,
      faqApi.middleware,
      tutorialApi.middleware,
      productCatalogApi.middleware,
      supportApi.middleware,
    ),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export default store;
